import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ResearchGateOverlay } from "./ResearchGateOverlay";
import { recordGateAcceptance as persistAcceptance, hasAcceptedGate, STORAGE_KEY } from "./gateStorage";
import { trackGateEvent } from "../../lib/gateAnalytics";

/**
 * First-time-visitor research confirmation for browse routes
 * (`/`, `/shop`, `/shop/*`, `/product/*`, `/categories`, `/category/*`).
 *
 * The page itself always renders, so its real content and metadata are in the
 * HTML for every visitor and crawler alike. Until the visitor confirms, the
 * existing research confirmation sits on top as a modal overlay and the page
 * underneath is `inert`. Yes stores `localStorage.mps_gate_accepted_v1`
 * and dismisses the overlay in place; No goes to /about.
 *
 * Not a checkout/purchase eligibility check — those live in the checkout flow
 * and are untouched. `?force=1` skips the overlay for one view (QA).
 */
export function FirstTimeVisitorGate({ children }) {
  const location = useLocation();
  const [accepted, setAccepted] = useState(hasAcceptedGate);
  const forced = new URLSearchParams(location.search || "").get("force") === "1";
  const open = !accepted && !forced;

  const accept = () => {
    persistAcceptance();
    trackGateEvent("eligibility_yes", { gate_display: "overlay" });
    setAccepted(true);
  };

  return (
    <>
      <div className="contents" inert={open} data-testid="gated-page-content">
        {children}
      </div>
      {open && <ResearchGateOverlay onAccept={accept} />}
    </>
  );
}

export { hasAcceptedGate, persistAcceptance as recordGateAcceptance, STORAGE_KEY as GATE_ACCEPTED_STORAGE_KEY };
